import {
	ProductKeys,
	type ProductKeys1P,
	type ProductKeys3P,
} from '../../../../../common/constants/products';
import { getProducts3PFromConfigForFilter } from '../../../../../common/utils/filters';
import { createBooleanFilter } from '../../../../filters/boolean-filter';

const productKeys1P: ProductKeys1P[] = [];

const originalProducts3P: ProductKeys3P[] = [
	ProductKeys.GoogleDrive,
	ProductKeys.Sharepoint,
	ProductKeys.Dropbox,
	ProductKeys.GoogleCalendar,
	ProductKeys.OneDrive,
];

const products3PFromConfig: ProductKeys3P[] = getProducts3PFromConfigForFilter('onlyTitleMatch');

const getProducts3P = () => {
	// fg('rovo-full-page-search-3p-static-config') => false
	return false ? products3PFromConfig : originalProducts3P;
};

export const filter = createBooleanFilter({
	id: 'onlyTitleMatch',
	queryParams: { key: 'titleMatch' },
	products: [...productKeys1P, ...getProducts3P()],
	alwaysVisible: true,
	universal: false,
});
